const MetricsConstants = {
	"METRIC_LOAD_PAGE_DATA": "LoadPageData",
	"METRIC_CANCEL_ORDER_REQUEST": "CancelOrderRequest",
	"METRIC_QR_CODE_VISIBLE": "QRCodeVisibility_Visible",
	"METRIC_QR_CODE_HIDDEN": "QRCodeVisibility_Hidden",
}

export default MetricsConstants;